import { instance } from '../../util/http'
import apis from '../../config/apis'

// 商品详情介绍图
const get = (Id) => {
    return instance.get(apis.Mini.Get + "?code=" + Id )
}

export default {
    get
}